export default "<img src=\"/assets/images/pages/oops.svg\" alt=\"\">"